module.exports = __webpack_public_path__ + "img/armellini_truck.2b70ed6e.png";